/**
 * @deprecated will be removed or significantly changed in future versions
 */
export interface ISpacing {
    "spacing-6x-small": string;
    "spacing-5x-small": string;
    "spacing-4x-small": string;
    "spacing-3x-small": string;
    "spacing-xx-small": string;
    "spacing-x-small": string;
    "spacing-small": string;
    "spacing-regular": string;
    "spacing-medium": string;
    "spacing-large": string;
    "spacing-x-large": string;
    "spacing-xx-large": string;
    "spacing-3x-large": string;
    "spacing-4x-large": string;
    "spacing-5x-large": string;
    "spacing-6x-large": string;
    "spacing-7x-large": string;
    "spacing-8x-large": string;
    "spacing-9x-large": string;
    "spacing-10x-large": string;
    "spacing-11x-large": string;
    "spacing-12x-large": string;
    "spacing-13x-large": string;
    "spacing-14x-large": string;
    "spacing-15x-large": string;
    "spacing-16x-large": string;
    "spacing-17x-large": string;
    "spacing-18x-large": string;
    "spacing-19x-large": string;
    "spacing-20x-large": string;
}
